import { Backdrop, Button, CircularProgress, FormControl, InputBase, MenuItem, Modal, Select, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import ChainMap from "./chainMap";
import { ethers } from "ethers";
import KwilDB from "kwildb";
import { useSelector } from "react-redux";


export default function AddPoolModal({ addingPool, setAddingPool, pools, setPools, setStatus, setErrMsg, count, setCount }) {
    const [poolName, setPoolName] = useState("")
    const [chain, setChain] = useState("")
    const [token, setToken] = useState("")
    const [loadAddingPool, setLoadAddingPool] = useState(false)
    const [emptyInput, setEmptyInput] = useState(false)

    const moatName = useSelector((state) => state.loadedMoat.value)
    
    function createPool(e) {
        e.preventDefault()
        const chainID = ChainMap().get(chain)
        setTimeout(async function () {
            if (window.ethereum.networkVersion !== chainID.int) {
                try {
                    await window.ethereum.request({
                        method: "wallet_switchEthereumChain",
                        params: [{ chainId: chainID.hex} ]
                    })
                } catch (err) {
                    if (err.message === "User rejected the request.") {
                        window.alert("User rejected the request")
                        return
                    } else {
                        window.alert("You do not have the specified chain added to your wallet!")
                        return
                    }
                }
            }
            setLoadAddingPool(true)
            await window.ethereum.send("eth_requestAccounts")
            const provider = new ethers.providers.Web3Provider(window.ethereum)
            const signer = provider.getSigner()
            const address= await signer.getAddress()
            
            const result = await KwilDB.pools.createFundingPool(
                poolName,
                address,
                address,
                chain,
                token,
                moatName
            )
            setLoadAddingPool(false)
            setAddingPool(false)
            if (typeof result === "string") {
                setStatus("fail")
                setErrMsg(result)
            } else {
                setStatus("success")
                setPools((old) => [
                    ...old,
                    {
                        pool_name: poolName,
                        validator: address,
                        blockchain: chain,
                        token: token
                    }
                ])
                setCount(count + 1)
            }
        }, 0)
    }

    return(
        <Modal
            open={addingPool}
            onClose={() => setAddingPool(false)}
            sx={{ display: "flex"}}
        >
            <div className="modal-intro pool">
                <p className="modal-title">
                    Create New Funding Pool
                </p>
                <Typography
                    sx={{
                        margin: "22px 6.689vw 0px",
                        color: "#fff",
                        fontFamily: "Averta",
                        fontWeight: "400" }}>
                    Funding Pool Name{emptyInput && <span>*</span>}
                </Typography>
                <InputBase
                    value={poolName}
                    placeholder={"Funding Pool Name"}
                    sx={{
                        backgroundColor: "#040417",
                        color: "#fff",
                        borderRadius: "9px",
                        pl: "10px",
                        minHeight: "45px",
                        margin: "5px 6.689vw",
                        border: "1px solid #114BA3",
                        fontFamily: "Averta",
                    }}
                    hiddenLabel={true}
                    id="outlined-basic"
                    variant="filled"
                    label=""
                    onChange={(e) => setPoolName(e.target.value.replace(/[^a-zA-Z0-9_ ]/g, '').replace(" ", "_").replace(/^[^a-zA-Z]/, ''))}
                />
                <Typography
                    sx={{
                        margin: "22px 6.689vw 0px",
                        color: "#fff",
                        fontFamily: "Averta",
                        fontWeight: "400"
                    }}
                >
                    Select Blockchain {emptyInput && <span>*</span>}
                </Typography>
                <FormControl
                    required
                    sx={{
                        backgroundColor: "#040417",
                        color: "#fff",
                        borderRadius: "9px",
                        pl: "10px",
                        minHeight: "45px",
                        margin: "5px 6.689vw",
                        border: "1px solid #114BA3",
                        fontFamily: "Averta",
                        paddingRight: "5px",
                        "& .MuiSelect-icon": { color: "#fff" }
                    }}
                >
                    <Select
                        displayEmpty
                        value={chain}
                        onChange={(e) => setChain(e.target.value)}
                        input={<InputBase />}
                        sx={{
                            backgroundColor: "#040417",
                            color: chain === "" ? "#6D6D79" : "#fff",
                            minHeight: "45px",
                            fontFamily: "Averta",
                        }}
                        IconComponent={ExpandMoreIcon}
                    >
                        <MenuItem disabled value="">
                            <em>Blockchain</em>
                        </MenuItem>
                        <MenuItem value="polygon">Polygon</MenuItem>
                    </Select>
                </FormControl>
                <Typography
                    sx={{
                        margin: "22px 6.689vw 0px",
                        color: "#fff",
                        fontFamily: "Averta",
                        fontWeight: "400"
                    }}
                >
                    Select Token {emptyInput && <span>*</span>}
                </Typography>
                <FormControl
                    required
                    sx={{
                        backgroundColor: "#040417",
                        color: "#fff",
                        borderRadius: "9px",
                        pl: "10px",
                        minHeight: "45px",
                        margin: "5px 6.689vw",
                        border: "1px solid #114BA3",
                        fontFamily: "Averta",
                        paddingRight: "5px",
                        "& .MuiSelect-icon": { color: "#fff" }
                    }}
                >
                    <Select
                        displayEmpty
                        value={token}
                        onChange={(e) => setToken(e.target.value)}
                        input={<InputBase />}
                        sx={{
                            backgroundColor: "#040417",
                            color: token === "" ? "#6D6D79" : "#fff",
                            minHeight: "45px",
                            fontFamily: "Averta",
                        }}
                        IconComponent={ExpandMoreIcon}
                    >
                        <MenuItem disabled value="">Token</MenuItem>
                        <MenuItem value="USDC">USDC</MenuItem>
                        {chain === "polygon" && <MenuItem value="KRED">KRED</MenuItem>}
                    </Select>
                </FormControl>
                <Button
                    sx={{
                        color: "#fff",
                        background: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)",
                        opacity: "0.9",
                        textTransform: "none",
                        margin: "40px auto",
                        borderRadius: "9px",
                        width: "19.028vw",
                        height: "49px",
                        fontFamily: "Averta",
                        fontWeight: "400",
                        fontSize: "20px",
                        lineHeight: "24px"
                    }}
                    onClick={createPool}
                >
                    Create Funding Pool
                </Button>
                <Backdrop sx={{ display: "flex", flexDirection: "column" }} open={loadAddingPool}>
                <CircularProgress sx={{ color: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)" }} />
                    <p style={{ margin: "20px auto", color: "#fff", fontFamily: "Averta" }}>
                    Please wait, this may take several minutes...
                </p>
                </Backdrop>
            </div>
        </Modal>
    )
}